import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=18ae8f6e&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18ae8f6e')) {
      api.createRecord('18ae8f6e', component.options)
    } else {
      api.reload('18ae8f6e', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=18ae8f6e&", function () {
      api.rerender('18ae8f6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2G5TlFMCfq87t/JS/pricehelp.vue"
export default component.exports